// extracted by mini-css-extract-plugin
export default {"informationContainer":"information_informationContainer__9rU-T"};